import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';

@Component({
  selector: 'app-button-toggle',
  templateUrl: './button-toggle.component.html',
  styleUrls: ['./button-toggle.component.scss']
})
export class ButtonToggleComponent implements OnInit {
  constructor() {}

  @Input() labelIfTrue = '';
  @Input() labelIfFalse = '';
  @Input() isToggle = false;
  @Output() toggleClick = new EventEmitter();

  ngOnInit() {}

  toggle() {
    this.isToggle = !this.isToggle;
    this.toggleClick.emit(this.isToggle);
  }
}
